import { gql } from '@apollo/client';

export const FETCH_UNIFIED_CONTACT_STATS = gql`
    query UnifiedContactStats {
        unifiedContactsByCloseness {
            effectiveCircle
            count
        }
        newUnifiedContacts
    }
`;

export const FETCH_QUESTIONS = gql`
    mutation CreateContactsGame {
        createContactGame(input: {}) {
            contactGame {
                id
                questions {
                    id
                    questionType
                    unifiedContact {
                        id
                        chosenCircle
                        proposedCircle
                        effectiveCircle
                        displayName
                        givenName
                        emailHash
                        primaryEmail
                        effectiveName
                        birthday
                        photoImageUrl
                        proposedHuman
                        chosenHuman
                    }
                    contactMapping {
                        id
                        contact {
                            displayName
                            photoImageUrl
                            primaryEmail
                            effectiveName
                            emailHash
                            birthday
                            account {
                                email
                            }
                        }
                    }
                }
            }
            errors {
                path
                message
            }
        }
    }
`;

export const UPDATE_QUESTIONS = gql`
    mutation UpdateQuestion($contactGameQuestion:UpdateContactGameQuestionInput!) {
        updateContactGameQuestion(input:$contactGameQuestion) {
            contactGameQuestion {
              id
                questionType
                response
                status
            }
            errors {
                path
                message
            }
        }
    }
`;
